export default "__VITE_ASSET__b19beabe__"